import * as React from 'react';
import classNames from 'classnames';
import './styles/Badge.scss';

type Props = {
  label: string;
  icon?: string;
  variant?: 'informative' | 'attention';
};

const Badge: React.FC<Props> = ({ label, icon, variant = 'informative' }) => {
  return (
    <div className={classNames('badge', `badge--${variant}`)}>
      {icon && <i className="material-symbols">{icon}</i>}
      <span className="badge-label">{label}</span>
    </div>
  );
};

export default Badge;
